import React from 'react';
import styles from "./styles.module.css"; // Ensure this is the correct path to your CSS module

function MostRecentSoldPriceDate({ mostRecentSoldPriceDateFilter, setMostRecentSoldPriceDateFilter }) {

    const today = new Date();
    const maxDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const handleStartDateChange = (e) => {
        setMostRecentSoldPriceDateFilter({ ...mostRecentSoldPriceDateFilter, startDate: e.target.value });
    };

    const handleEndDateChange = (e) => {
        setMostRecentSoldPriceDateFilter({ ...mostRecentSoldPriceDateFilter, endDate: e.target.value });
    };

    return (
        <div className={styles.RecentStatusDateContainer}>
            <h1 className={styles.RecentStatusDateTitle}>Most recent sold price date</h1>
            <div className={styles.RecentStatusDateInputContainer}>
                <input
                    className={styles.RecentStatusDateInput}
                    type="date"
                    name="startDate"
                    max={maxDate}
                    value={mostRecentSoldPriceDateFilter.startDate}
                    onChange={handleStartDateChange}
                    required
                />
                <span className={styles.RecentStatusDateLabel}>to</span>
                <input
                    className={styles.RecentStatusDateInput}
                    type="date"
                    name="endDate"
                    max={maxDate}
                    value={mostRecentSoldPriceDateFilter.endDate}
                    onChange={handleEndDateChange}
                    required
                />
            </div>
        </div>
    );
}

export default MostRecentSoldPriceDate;
